<template>
    <div id="AssetStandardFeature">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <template v-if="assetStandardVal != undefined">
            <div class="bg-white data-table p-0">
                <vue-good-table
                    ref="listStandardFeatureTable"
                    mode="remote"
                    title="Standard Feature"
                    @on-page-change="onPageChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    @on-sort-change="onSortChange"
                    :totalRows="totalRecords"
                    :columns="columns"
                    :rows="rows"
                    :pagination-options="{
                        enabled: true,
                        position: 'bottom',
                        perPage: perPage,
                        perPageDropdown:dropDownPerPage,
                        dropdownAllowAll: false,
                    }"
                    :select-options="{
                        enabled: asset_component_value,
                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'clear',
                    }"
                    >
                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                        <div :key="key">
                            <div v-if="props.column.field == 'action'" class='text-center'>
                                <router-link v-if="canUpdate" title="Edit Standard Feature" v-bind:key="'action'+index" class="fp-edit" v-bind:to="{name: 'AssetFeatureEdit',params:{id:props.row.id}}"></router-link>
                            </div>
                            <div v-else>
                                {{props.formattedRow[props.column.field]}}
                            </div>
                        </div>
                    </template>
                     <div slot="selected-row-actions">
                        <button v-if="canDelete == true" id="deleteVehicleTypeBtn" v-on:click.prevent="StandardFeatureDelete" class="btn btn-primary">Delete</button>
                    </div>
                </vue-good-table>
            </div>
        </template>

        <div id="page-content-wrapper" class="admin-content-area" v-else>
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">
                        Assets Standard Feature
                        <!-- <router-link v-if="addAssetComponent" class="btn btn-success waves-effect pull-right" v-bind:to="{name: 'AssetComponentCreate',params:{flag:'fromList'}}">
                                Add
                        </router-link> -->
                    </div>
                    <div class="admin-page-content customer-detail">
                        <section class="internal-container">
                            <div class="container">
                                <vue-good-table
                                    ref="listStandardFeatureTable"
                                    mode="remote"
                                    title="Standard Feature"
                                    @on-page-change="onPageChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="columns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: true,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: asset_component_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"

                                    >
                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'" class='btn-center-vvg'>
                                                <router-link v-if="canUpdate" title="Edit Standard Feature" class="glyphicon glyphicon-edit" v-bind:to="{name: 'AssetStandardFeaturesEdit',params:{id:props.row.standard_feature_id}}"></router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                    <div slot="selected-row-actions">
                                        <button v-if="canDelete" id="deleteVehicleTypeBtn" v-on:click.prevent="VehicleComponentDelete" class="btn btn-success waves-effect">Delete</button>
                                    </div>
                                </vue-good-table>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import EventBus from ".././event-bus";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';


var contex
    export default {
        name: "AssetStandardFeature",
        mixins:[commonMixins,dataTableMixins],
        props: {
            assetStandardVal: {
                type: String,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            asset_component_value:false,
            columns: [
                {
                    label: 'Category Name',
                    field: 'name',
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Category Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Feature',
                    field: 'feature',
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Feature", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Weight Front',
                    field: 'weight_front',
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Weight Front", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Weight Rear',
                    field: 'weight_rear',
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Weight Rear", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

                {
                    label: 'Added By',
                    field: 'created_by',
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Added By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
            ],
            rows: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: 'id',
                    type: 'desc',
                },
                page: 1,
                perPage: 100
            },
            loading:false,
            canAdd:false,
            canUpdate:false,
            canDelete:false
        }),
        metaInfo () {
            if (this.assetStandardVal == undefined) {
                return {
                    title: "Asset Standard Feature List | " +process.env.COPYRIGHT_NAME
                }
            }
        },
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_asset_standard_feature') {
                            self.cantAccessPage = true;
                            self.asset_component_value = true;
                        }
                        if (permissions[i].name == 'add_asset_standard_feature') {
                            self.canAdd = true;
                            self.canUpdate = true;
                        }
                        if (permissions[i].name == 'delete_asset_standard_feature') {
                            self.canDelete = true;
                        }
                    }
                }
            }

        },
        created: function() {

        },
        beforeDestroy(){
            // this.$root.$off('standard_features');
        },
        mounted: function() {
            var self = this;
            //self.loadAssetContracts();
            // self.getPermissions();
            // if (this.assetComponentVal == 'loaded' ){
            //     this.loadAssetComponent();
            // }
            // this.$root.$on('standard_features', () => {

            // });
            //when component list directly call from url instead of in view page than call permission request
            if ( self.assetStandardVal == undefined ) {
                self.getPermissions();
            }else{
                var path = window.location.pathname;
                var asset = path.split("/");
                self.assetId = asset[3];
                self.assetStandardVal = "loadList";
                self.flag = 'features';
                // self.getPermissions();
                self.loadAssetStandardFeatures();
            }
        },
        methods: {

            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                var self = this;
                this.updateParams({page: params.currentPage});
                if (this.firstLoad == 1 || self.assetStandardVal == undefined){
                    this.loadAssetStandardFeatures();
                }
            },

            onPerPageChange(params) {
                var self = this;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.serverParams.page = 1 ;
                if (this.firstLoad == 1 || self.assetStandardVal == undefined){
                    this.loadAssetStandardFeatures();
                }
            },

            onColumnFilter(params) {
                this.updateParams(params);
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                this.serverParams.page = 1 ;
                if (this.firstLoad == 1 || filters.unit || filters.name || filters.contract || filters.effective_date || filters.expiry_date || filters.assignment_date || filters.assigned_facility || filters.assigned_by ) {
                    this.loadAssetStandardFeatures();
                }
            },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadAssetStandardFeatures();
            },

            loadAssetStandardFeatures() {
                var self = this;
                // if(self.assetStandardVal == 'features'){

                    // var path = window.location.pathname;
                    // var asset = path.split("/");
                    // self.assetId = asset[3];
                    // self.flag = 'features';

                // }
                if( self.assetStandardVal == 'dontLoadList' ){
                    return;
                }
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    flag: self.flag,
                    asset_id: self.assetId
                };
                self.firstLoad = 1;

                $.ajax({
                    url: process.env.ROOT_API + "/asset_standard_feature/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'asset-std-list')
                    }
                });
            },
            StandardFeatureDelete() {
            var data = this.$refs['listStandardFeatureTable'].selectedRows;
            var self = this;
            var use = [];


            if (confirm('Are you sure that you want to delete this Standard Feature? ')) {
                self.loading = true;
                $("#deleteVehicleTypeBtn").val("Deleting ...");
                $.ajax({
                    url: process.env.ROOT_API + "/standard_feature/delete",
                    type: "POST",
                    data: {
                    fields:this.$refs['listStandardFeatureTable'].selectedRows
                    },
                    headers: this.ajxHeaders,
                    dataType: 'json',
                    success: function (data) {
                        self.loading = false;
                        setTimeout(function () {
                        $(".alert-success").removeClass("show");
                            $(".alert-success").addClass("hide");
                        }, 10000);
                        setTimeout(function () {
                            $("#deleteVehicleTypeBtn").val("Delete");
                        }, 10000);

                        if (data.code == '200') {
                        self.loadAssetStandardFeatures();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'asset-std-delete')

                    }
                });
            }
        }
        }
    };

</script>

<style scope>
#AssetContract .vgt-wrap {
    float: none;
}
</style>



// WEBPACK FOOTER //
// src/components/asset/AssetStandardFeature.vue